<template>
    <div v-if="loaded" v-for="m in messages">{{ m }}</div>
    <div v-else>Loading...</div>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";
import { Thread, RichMessage } from "@/src/model/ChatApi";

import { useStore } from "vuex";
const store = useStore();
const messages = computed<RichMessage[]>(() => store.getters["chatbotStore/messages"]);

const overview = computed(() => {
    let agents: (Thread & { messages: (RichMessage | null)[] })[] = [];
    for (let m of messages.value) {
        let agent = agents.find((a) => a.id == m.thread.id);
        if (!agent) {
            agent = {
                id: m.thread.id,
                name: m.thread.name,
                messages: [],
            };
            agents.push(agent);
        }
        agent.messages.push(m);
        agents.forEach((a) => {
            if (a != agent) {
                a.messages.push(null);
            }
        });
    }
    return agents;
});
const loaded = ref(false);
onMounted(async () => {
    console.log("INSPECTOR MOUNTED");
    await store.dispatch("chatbotStore/inspectConversation");
    loaded.value = true;
});

const id = computed(() => store.getters["chatbotStore/conversationId"]);
onUnmounted(() => {
    console.log("INSPECTOR UNMOUNTED, restoring conversation: " + id.value);
    store.dispatch("chatbotStore/getSpecificConversation", {
        conversationId: id.value,
    });
});
</script>
<style scoped></style>
